import React from 'react';
import chunk from 'lodash/chunk';
import {
  PRODUCT_WIDGET_LAYOUT_TYPE_V2,
  ProductWidgetDetailV2,
  WidgetProductItem,
} from '../../../../../../../types/widget';
import Slider from '../../../../../../../components/utils/Slider/Slider';
import PreviewProductCard from '../../../../../../../components/preview/PreviewProductCard';
import { ProductWidgetGridLayoutStyle } from './style';
import PreviewGrid from '../../../../../../../components/preview/PreviewGrid';

export type ProductWidgetGridLayoutDetail = ProductWidgetDetailV2 & {
  layoutType: typeof PRODUCT_WIDGET_LAYOUT_TYPE_V2.GRID_2X2 | typeof PRODUCT_WIDGET_LAYOUT_TYPE_V2.GRID_3X2;
};

interface ProductWidgetGridLayoutProps {
  detail: ProductWidgetGridLayoutDetail;
}

export const ProductWidgetGridLayout = (props: ProductWidgetGridLayoutProps) => {
  const { detail } = props;
  const layoutInfo =
    detail.layoutType === PRODUCT_WIDGET_LAYOUT_TYPE_V2.GRID_2X2 ? { row: 2, col: 2 } : { row: 3, col: 2 };

  return (
    <ProductWidgetGridLayoutStyle>
      <Slider
        emptyText={
          detail.isProductRecommend ? (
            <>
              자동 추천 위젯은 <br /> 위젯 아이템 미리보기가 불가합니다.
            </>
          ) : (
            '홈에 노출 될 위젯 아이템 리스트 설정해주세요.'
          )
        }
        list={chunk(detail.exposureWidgetItemProducts, layoutInfo.row * layoutInfo.col)}
        arrows={false}
        adaptiveHeight={false}
        item={(section: WidgetProductItem[]) => (
          <PreviewGrid col={layoutInfo.col} rowGap={15} colGap={15} style={{ padding: '0px 16px' }}>
            {section.map((productItem) => (
              <PreviewProductCard key={productItem.id} product={productItem} />
            ))}
          </PreviewGrid>
        )}
      />
    </ProductWidgetGridLayoutStyle>
  );
};

export default ProductWidgetGridLayout;
